<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ch-title"><a id="page_3">Dramatis Personæ</a></h2><a id="page_3">
<p class="noindent">Oedipus.</p>
<p class="noindent1">The Priest of Zeus.</p>
<p class="noindent1">Creon.</p>
<p class="noindent1">Chorus of Theban Elders.</p>
<p class="noindent1">Teiresias.</p>
<p class="noindent1">Jocasta.</p>
<p class="noindent1">Messenger.</p>
<p class="noindent1">Herd of Laius.</p>
<p class="noindent1">Second Messenger.</p>
</a><p class="center1"><a id="page_3"></a><a id="page_4"><span class="bold">Scene: Thebes. Before the Palace of Oedipus</span></a></p><a id="page_4">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Chapter01.vue?eccc4544